import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import {
  CreateAccountAPI,
  CreateCustomerPaymentApi,
  CreateSupplierPaymentApi,
  SignUpApi,
} from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import CustomerSelector from "../Selector/CustomerSelector";
import { fetchCustomerPayments } from "../../store/Slices/CustomerPaymentSlice";
import CustomTabs from "../Tabs/CustomTabs";
import CompanySelector from "../Selector/CompanySelector";
import TypeSelector from "../Selector/TypeSelector";
import PaymentTypeSelector from "../Selector/PaymentTypeSelector";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";
import { fetchAccounts } from "../../store/Slices/AccountSlice";
import AuthInputPassword from "../Input/AuthInputPassword";

// Get user data with null checks
const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId } = userData;

const AddBranchModal = ({ Open, setOpen }) => {
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Customer");

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let payload = {
      name: "Admin",
      email: "admin@gmail.com",
      password: "12345678",
      role: 1,
    };

    if (false) WarningToast("Valid Branch Details Required");
    else {
      try {
        let response = await SignUpApi({
          ...payload,
        });

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Branch added successfully");
          dispatch(fetchAccounts());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.error(err);
        ErrorToast(err.response.data.error.msg);
        ErrorToast("Failed to add payment");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Branch
        </h1>
        <div className="flex gap-4 max696:flex-col px-10 max696:max-h-[70vh] max696:overflow-y-auto">
          <div className="flex flex-col gap-y-4">
            <AuthInput
              label="Name"
              placeholder="Enter Branch Name"
              Value={Name}
              setValue={setName}
            />
            <AuthInput
              label="Email"
              placeholder="Enter Branch Email"
              Value={Email}
              setValue={setEmail}
            />
            <AuthInputPassword
              label={"Password"}
              placeholder={"Enter Password"}
              Value={Password}
              setValue={setPassword}
              required={false}
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Branch"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddBranchModal;
